import { render } from "./RelatDespesaSemanal.vue?vue&type=template&id=ecd0f666"
import script from "./RelatDespesaSemanal.vue?vue&type=script&lang=js"
export * from "./RelatDespesaSemanal.vue?vue&type=script&lang=js"

import "./RelatDespesaSemanal.vue?vue&type=style&index=0&id=ecd0f666&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__